import { RecordKind } from '../record.js';
export function isOption(value) {
    return typeof (value) === 'object' && '_id' in value && value.kind === RecordKind.Option;
}
export function isNoRestriction(vs) {
    return vs.kind == 'NO_RESTRICTIONS';
}
export function isRestrictedTo(vs) {
    return vs.kind === 'RESTRICTED_TO';
}
export function noRestrictions() {
    return {
        kind: 'NO_RESTRICTIONS'
    };
}
export function restrictedTo(values) {
    return {
        kind: 'RESTRICTED_TO',
        values
    };
}
function isValuesCompatibleValues(values) {
    if (values.length <= 1) {
        return true;
    }
    const firstValueType = typeof values[0];
    return values.slice(1).every(v => typeof v === firstValueType);
}
export function castCompatibleValue(compatibleValues) {
    if (isValuesCompatibleValues(compatibleValues)) {
        return compatibleValues;
    }
    else {
        throw new Error('Incompatible results of compatible values');
    }
}
//# sourceMappingURL=CompatibleValues.js.map